// extracted by mini-css-extract-plugin
export default {"cartButton":"BookCard_cartButton__ssGsv","cardTemplate":"BookCard_cardTemplate__6yOwy","bookImage":"BookCard_bookImage__dGAs6","buttons":"BookCard_buttons__yVWmg"};